import React, { useState, useEffect, useRef, forwardRef } from 'react'
import siteVars from '~/Classes/siteVars'
import i18n from '../../../../../i18n'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import axios from '../../../../../data/http/axios'
import SocialTwitterPreview from './previews/twitter'
import SocialFacebookPreview from './previews/facebook'
import SocialLinkedinPreview from './previews/linkedin'
import SocialInstagramPreview from './previews/instagram'
import DisplayCard from '~/Common-Objects/UI/DisplayCard'
import helpers from '~/Classes/helpers'
import linkCache from '~/Classes/linkCache'

export function SocialImageSelector({
    VideoId,
    video,
    image,
    index = -1,
    onAdd = () => {},
    onRemove = () => {},
    onEdit = () => {},
    setVideo = () => {},
    setImage = () => {}
}) {
    const timer = useRef(null)

    const getVideo = async () => {
        const res = await axios.get('/video/' + VideoId)
        setVideo(res.data)
        if (!res.data.thumbs?.length) {
            timer.current = setTimeout(getVideo, 1000)
        }
    }

    useEffect(() => {
        if (VideoId) getVideo()

        return function () {
            if (timer.current) clearTimeout(timer.current)
        }
    }, [VideoId])

    const style = {
        backgroundSize: 'cover',
        backgroundPositionX: 'center',
        backgroundPositionY: 'center',
        backgroundRepeat: 'no-repeat',
        height: 85,
        borderRadius: 8,
        backgroundColor: 'transparent',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
    if (image && VideoId) {
        // style.backgroundImage = `url(${image.url || image})`
        return (
            <div className='social-images-selector'>
                <div style={style}>
                    <div
                        style={{
                            overflow: 'hidden',
                            overflowWrap: 'anywhere',
                            textAlign: 'center',
                            padding: 4
                        }}
                    >
                        {video.filename}
                    </div>
                    <Icons
                        data-tooltip-content='Remove'
                        data-tooltip-id={'remove-' + index}
                        icon='crossCircle'
                        color='black'
                        style={{ position: 'absolute', top: -4, right: -4, cursor: 'pointer' }}
                        onClick={onRemove}
                    />
                </div>
                {!!video.thumbs?.length && (
                    <div className='mar-t10 mar-b30'>
                        <div className='txtInput_label'>Select Thumbnail (only supported on Facebook and LinkedIn)</div>
                        <div className='quickFlex' style={{ flexWrap: 'wrap', gap: 10 }}>
                            {video.thumbs.map((thumb, i) => {
                                let classes = 'social-video-thumb'
                                if (thumb === video.thumb) {
                                    classes += ' selected'
                                }
                                return (
                                    <img
                                        src={`${siteVars.repoEndPoint + thumb}`}
                                        className={classes}
                                        onClick={() => setImage(thumb)}
                                        key={i}
                                        style={{ ...style, width: 'auto' }}
                                    />
                                )
                            })}
                        </div>
                    </div>
                )}
            </div>
        )
    } else if (image) {
        style.backgroundImage = `url(${image.url || image})`
        return (
            <div style={{ display: 'block' }}>
                <div className='social-images-selector' style={style}>
                    <Icons
                        data-tooltip-content='Remove'
                        data-tooltip-id={'remove-' + index}
                        icon='crossCircle'
                        color='black'
                        style={{
                            position: 'absolute',
                            top: -4,
                            right: -4,
                            cursor: 'pointer',
                            zIndex: 20,
                            borderRadius: '100%',
                            backgroundColor: 'white'
                        }}
                        onClick={onRemove}
                    />
                    <div className='social-images-selector__imagehover'>
                        <Button
                            className='button-sml button-grey'
                            onClick={onEdit}
                            iconLeft={<Icons icon='wand' />}
                        >
                            Edit
                        </Button>
                    </div>
                </div>
                {!!(image.imageWidth && image.imageHeight) && (
                    <div className='text-grey text-xsml mar-t5' style={{ textAlign: 'center' }}>
                        {image.imageWidth} x {image.imageHeight}
                    </div>
                )}
            </div>
        )
    } else if (VideoId) {
        style.border = '1px dashed grey'
        style.display = 'flex'
        style.justifyContent = 'center'
        style.alignItems = 'center'
        return (
            <div>
                <div className='social-images-selector' style={style}>
                    <LoadingIcons style={{ top: 0 }} />
                </div>
                <div className='text-grey text-heavy'>Video being processed, please wait</div>
            </div>
        )
    } else {
        style.border = '1px dashed var(--neutral-400)'
        style.display = 'flex'
        style.justifyContent = 'center'
        style.alignItems = 'center'
        return (
            <div>
                <div className='social-images-selector' style={style}>
                    <Button
                        className='button-sml button-grey'
                        iconLeft={<Icons icon='plus' />}
                        onClick={onAdd}
                    >
                        Add
                    </Button>
                </div>
            </div>
        )
    }
}

const SocialPreview = forwardRef(function SocialPreview(
    { text, images = [], provider, site, SocialAccountId, warning = true, startDate = new Date(), video = false },
    ref
) {
    const [overwriteSite, setOverwriteSite] = useState(null)
    const [foundLink, setFoundLink] = useState(null)

    useEffect(() => {
        const fetchLinkPreview = async () => {
            const links = helpers.findLinks(text)
            if (links.length) {
                const url = links[links.length - 1]

                // Check shared cache first
                if (linkCache.has(url)) {
                    setFoundLink(linkCache.get(url))
                    return
                }

                try {
                    const res = await axios.post('/campaign/link/preview', { url })
                    const result = res.data.error ? null : res.data.title || res.data.image ? res.data : null

                    // Store in shared cache
                    if (result) {
                        linkCache.set(url, result)
                    }
                    setFoundLink(result)
                } catch (error) {
                    // Clear shared cache and state on error
                    linkCache.remove(url)
                    setFoundLink(null)
                }
            } else {
                // No links found, clear the preview
                setFoundLink(null)
            }
        }

        // Debounce the API call
        const timer = setTimeout(fetchLinkPreview, 500)

        return () => clearTimeout(timer)
    }, [text])

    useEffect(() => {
        if (SocialAccountId) {
            getSites(provider.code).then((sites) => {
                const found = sites.find((s) => s.id === SocialAccountId)
                if (found) setOverwriteSite(found)
            })
        }
    }, [SocialAccountId])

    if (!site && overwriteSite) site = overwriteSite
    if (provider && !site) return null

    text = text.replace(/\n/g, '<br />')
    let content

    if (provider?.code === 'FACEBOOK') {
        content = (
            <SocialFacebookPreview
                account={site}
                content={text}
                images={images}
                foundLink={foundLink}
                startDate={startDate}
                video={video}
            />
        )
    }

    if (provider?.code === 'LINKEDIN') {
        content = (
            <SocialLinkedinPreview
                account={site}
                content={text}
                images={images}
                foundLink={foundLink}
                startDate={startDate}
                video={video}
            />
        )
    }

    if (provider?.code === 'INSTAGRAM') {
        content = (
            <SocialInstagramPreview account={site} content={text} images={images} startDate={startDate} video={video} />
        )
    }

    if (provider?.code === 'TWITTER') {
        content = (
            <SocialTwitterPreview
                account={site}
                content={text}
                images={images}
                foundLink={foundLink}
                startDate={startDate}
                video={video}
            />
        )
    }

    return (
        <div style={{ display: 'block' }} ref={ref}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>{content}</div>
            {warning && (
                <div
                    style={{
                        marginTop: 32,
                        color: '#7C8086',
                        fontSize: 12,
                        fontWeight: 400,
                        lineHeight: '16px',
                        maxWidth: 480,
                        textAlign: 'center'
                    }}
                >
                    This preview is only an approximation of how your post will look. Your post may appear slightly
                    differently once published.
                </div>
            )}
        </div>
    )
})
export { SocialPreview as SocialPreview }

const LinkPreview = ({ title, image }) => (
    <DisplayCard>
        <DisplayCard.Image>
            <img src={image} alt='Link Preview' />
        </DisplayCard.Image>
        <DisplayCard.Content>
            <strong style={{ padding: '4px', lineHeight: '16px', fontSize: '14px' }}>{title}</strong>
        </DisplayCard.Content>
    </DisplayCard>
)

export { LinkPreview as LinkPreview }

export async function getSites(name, force) {
    let q = '?'
    if (force) q += 'force=true'
    const res = await axios.get('/application/' + name + '/sites' + q)
    return res.data
}

export async function connect(site, user, appData) {
    let ourTrackingDomain = site.trackingDomain
    if (ourTrackingDomain === 'api.transpond.io') {
        ourTrackingDomain = 'api.mpzmail.com'
    } else if (ourTrackingDomain === 'localhost:8082') {
        ourTrackingDomain = 'localhost:8082'
    }

    var theURI
    if (appData.authType === 'oAuth') {
        theURI = appData.oAuthAuthoriseUri
        theURI = theURI.replace(/\[OAUTHCLIENTID\]/g, appData.oAuthAppId)
        theURI = theURI.replace(/\[RANDNO\]/g, user.token)
        var redirectURI = window.location.origin
        if (redirectURI === 'https://app.transpond.io') {
            redirectURI = 'https://web.mpzmail.com'
        } else if (redirectURI === 'http://localhost:8082') {
            redirectURI = 'http://localhost:8082'
        }
        var toReplaceWith = redirectURI + '/cp/company/integrations/oAuth/response/' + appData.id
        if (appData.options && appData.options.backendAuth) {
            toReplaceWith = 'https://' + ourTrackingDomain + '/api/oauth/app/' + appData.id + '/oauth'
        }
        theURI = theURI.replace(/\[OAUTHREDIRECTURL\]/g, toReplaceWith)

        //if there are extra params defined, add them on
        var okToGo = true
        var errors = {}
        if (appData.options && appData.options.oAuthoriseUriParams && appData.options.oAuthoriseUriParams.length) {
            appData.options.oAuthoriseUriParams.forEach((theOpt) => {
                if (theOpt.required) {
                    if (!theOpt.value) {
                        errors[theOpt.key] = 'Required'
                        okToGo = false
                    } else if (theOpt.isUrl) {
                        // test its a url
                        var regex = new RegExp(/^(https):\/\/[^\s$.?#].[^\s]*$/gm)
                        if (theOpt.value.indexOf('https://') !== 0) {
                            errors[theOpt.key] = 'Invalid Url - must start with https://'
                            okToGo = false
                        } else if (!regex.test(theOpt.value)) {
                            errors[theOpt.key] = 'Invalid Url - must start with https://'
                            okToGo = false
                        }
                    }
                }
                theURI += '&' + theOpt.key + '=' + theOpt.value
            })
        }
    } else if (appData.id === 85) {
        // twitter link to oauth1
        try {
            const res = await axios.get('/application/twitter/authlink')
            theURI = res.data.url
        } catch (e) {
            appData.disabled = true
            console.log(e)
        }
    }
    return theURI
}

const iconChipStyle = {
    height: 15,
    width: 15,
    // borderRadius: '4px 0 0 4px'
    borderRadius: '100%'
}

export const SupportedApps = [
    {
        name: i18n.t('social:channels.facebook'),
        desc: i18n.t('social:channels.facebookDesc'),
        id: 77,
        code: 'FACEBOOK',
        logo: 'https://cdn1.ourmailserv.com/siteContent/appLogos/77/Facebook-logo.png',
        icon: 'facebookColor',
        width: 480,
        limit: 5000,
        formats: ['JPEG', 'JPG', 'PNG', 'GIF'],
        dimensions: [940, 788],
        colour: '#1877F2',
        hasStats: true,
        hideOutreach: false,
        hideImpressions: false,
        fileLimit: 1048576 * 10,
        maxImages: 20,
        click: (post) => {
            window.open('https://www.facebook.com/' + post.PostId, '_blank')
        },
        chipIcon: (
            <svg
                xmlns='http://www.w3.org/2000/svg'
                style={iconChipStyle}
                width='18'
                height='18'
                viewBox='0 0 18 18'
                fill='none'
            >
                <g clipPath='url(#clip0_462_15957)'>
                    <rect width='18' height='18' fill='#1877F2' />
                    <path
                        d='M12.5023 11.6016L12.9013 9H10.4052V7.31174C10.4052 6.60001 10.7539 5.90625 11.8719 5.90625H13.0068V3.69141C13.0068 3.69141 11.9768 3.51562 10.9922 3.51562C8.93636 3.51562 7.59273 4.76156 7.59273 7.01719V9H5.30757V11.6016H7.59273V18.8907C8.05094 18.9626 8.52057 18 8.99898 18C9.47738 18 9.94702 18.9626 10.4052 18.8907V11.6016H12.5023Z'
                        fill='white'
                    />
                </g>
                <defs>
                    <clipPath id='clip0_462_15957'>
                        <rect width='18' height='18' fill='white' />
                    </clipPath>
                </defs>
            </svg>
        )
    },
    {
        name: i18n.t('social:channels.instagram'),
        desc: i18n.t('social:channels.instagramDesc'),
        id: 77,
        code: 'INSTAGRAM',
        logo: 'https://cdn1.ourmailserv.com/siteContent/appLogos/77/Instagram-Logo.png',
        icon: 'instagramColor',
        width: 375,
        limit: 2200,
        formats: ['JPEG', 'JPG', 'PNG', 'BMP'],
        dimensions: [1080, 1080],
        colour: '#E63A7E',
        hasStats: true,
        hideOutreach: false,
        hideImpressions: false,
        fileLimit: 1048576 * 8,
        maxImages: 20,
        click: (post) => {
            axios.get('/application/instagram/post/' + post.id).then((res) => {
                window.open(res.data.permalink, '_blank')
            })
        },
        chipIcon: (
            <svg
                style={iconChipStyle}
                width='18'
                height='18'
                viewBox='0 0 18 18'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <rect width='18' height='18' fill='#E63A7E' />
                <g clipPath='url(#clip0_462_15963)'>
                    <path
                        d='M8.99999 4.0811C10.6021 4.0811 10.7918 4.0872 11.4245 4.11607C12.0095 4.14277 12.3272 4.24051 12.5386 4.32266C12.8187 4.4315 13.0186 4.56154 13.2285 4.77149C13.4385 4.98143 13.5685 5.18133 13.6773 5.46137C13.7595 5.67282 13.8572 5.99051 13.8839 6.57549C13.9128 7.20818 13.9189 7.39794 13.9189 9.00001C13.9189 10.6021 13.9128 10.7918 13.8839 11.4245C13.8572 12.0095 13.7595 12.3272 13.6773 12.5387C13.5685 12.8187 13.4385 13.0186 13.2285 13.2285C13.0186 13.4385 12.8187 13.5685 12.5386 13.6773C12.3272 13.7595 12.0095 13.8573 11.4245 13.884C10.7919 13.9128 10.6022 13.9189 8.99999 13.9189C7.39782 13.9189 7.20807 13.9128 6.57549 13.884C5.99049 13.8573 5.6728 13.7595 5.46137 13.6773C5.18131 13.5685 4.98141 13.4385 4.77146 13.2285C4.56152 13.0186 4.43148 12.8187 4.32266 12.5387C4.24049 12.3272 4.14274 12.0095 4.11604 11.4245C4.08718 10.7918 4.08108 10.6021 4.08108 9.00001C4.08108 7.39794 4.08718 7.20818 4.11604 6.57551C4.14274 5.99051 4.24049 5.67282 4.32266 5.46137C4.43148 5.18133 4.56152 4.98143 4.77146 4.77149C4.98141 4.56154 5.18131 4.4315 5.46137 4.32266C5.6728 4.24051 5.99049 4.14277 6.57546 4.11607C7.20816 4.0872 7.39791 4.0811 8.99999 4.0811ZM8.99999 3C7.37047 3 7.16617 3.00691 6.52621 3.03611C5.88755 3.06526 5.45142 3.16667 5.06975 3.315C4.6752 3.46834 4.34059 3.6735 4.00703 4.00706C3.67347 4.34061 3.46831 4.67522 3.31498 5.06977C3.16665 5.45144 3.06523 5.88758 3.03608 6.52623C3.00688 7.16617 3 7.3705 3 9.00001C3 10.6295 3.00688 10.8339 3.03608 11.4738C3.06523 12.1124 3.16665 12.5486 3.31498 12.9303C3.46831 13.3248 3.67347 13.6594 4.00703 13.993C4.34059 14.3265 4.6752 14.5317 5.06975 14.685C5.45142 14.8334 5.88755 14.9348 6.52621 14.9639C7.16617 14.9931 7.37047 15 8.99999 15C10.6295 15 10.8338 14.9931 11.4738 14.9639C12.1124 14.9348 12.5486 14.8334 12.9302 14.685C13.3248 14.5317 13.6594 14.3265 13.9929 13.993C14.3265 13.6594 14.5317 13.3248 14.685 12.9303C14.8333 12.5486 14.9347 12.1124 14.9639 11.4738C14.9931 10.8339 15 10.6295 15 9.00001C15 7.3705 14.9931 7.16617 14.9639 6.52623C14.9347 5.88758 14.8333 5.45144 14.685 5.06977C14.5317 4.67522 14.3265 4.34061 13.9929 4.00706C13.6594 3.6735 13.3248 3.46834 12.9302 3.315C12.5486 3.16667 12.1124 3.06526 11.4738 3.03611C10.8338 3.00691 10.6295 3 8.99999 3ZM8.99999 5.91892C7.29836 5.91892 5.9189 7.29838 5.9189 9.00001C5.9189 10.7016 7.29836 12.0811 8.99999 12.0811C10.7016 12.0811 12.0811 10.7016 12.0811 9.00001C12.0811 7.29838 10.7016 5.91892 8.99999 5.91892ZM8.99999 11C7.89543 11 6.99998 10.1046 6.99998 9.00001C6.99998 7.89545 7.89543 7 8.99999 7C10.1046 7 11 7.89545 11 9.00001C11 10.1046 10.1046 11 8.99999 11ZM12.9228 5.79719C12.9228 6.19484 12.6005 6.5172 12.2028 6.5172C11.8052 6.5172 11.4828 6.19484 11.4828 5.79719C11.4828 5.39954 11.8052 5.0772 12.2028 5.0772C12.6005 5.0772 12.9228 5.39954 12.9228 5.79719Z'
                        fill='white'
                    />
                </g>
                <defs>
                    <clipPath id='clip0_462_15963'>
                        <rect width='12' height='12' fill='white' transform='translate(3 3)' />
                    </clipPath>
                </defs>
            </svg>
        )
    },
    {
        name: i18n.t('social:channels.linkedin'),
        desc: i18n.t('social:channels.linkedinDesc'),
        id: 76,
        code: 'LINKEDIN',
        logo: 'https://cdn1.ourmailserv.com/siteContent/appLogos/76/linkedin1.png',
        icon: 'linkedinColor',
        width: 480,
        limit: 3000,
        formats: ['JPEG', 'JPG', 'PNG', 'GIF'],
        dimensions: [1200, 627],
        colour: '#0A66C2',
        hasStats: true,
        fileLimit: 1048576 * 5,
        maxImages: 20,
        click: (post) => {
            window.open('https://www.linkedin.com/feed/update/' + post.PostId, '_blank')
        },
        chipIcon: (
            <svg
                xmlns='http://www.w3.org/2000/svg'
                style={iconChipStyle}
                width='18'
                height='18'
                viewBox='0 0 18 18'
                fill='none'
            >
                <rect width='18' height='18' fill='#0A66C2' />
                <path
                    d='M14.9991 14.9798H12.5146V11.0887C12.5146 10.1609 12.498 8.96645 11.2223 8.96645C9.92828 8.96645 9.73029 9.97739 9.73029 11.0212V14.9795H7.24571V6.97797H9.6309V8.07147H9.66429C10.1506 7.23988 11.055 6.74321 12.0177 6.77894C14.5359 6.77894 15.0002 8.43536 15.0002 10.5903L14.9991 14.9798ZM4.44227 5.88422C3.64597 5.88436 3.00033 5.23893 3.00018 4.44261C3.00004 3.64629 3.64545 3.00063 4.44176 3.00049C5.23806 3.00035 5.8837 3.64577 5.88385 4.44209C5.88392 4.8245 5.73208 5.19127 5.46173 5.46172C5.19138 5.73217 4.82467 5.88415 4.44227 5.88422ZM5.68456 14.9798H3.1974V6.97797H5.68456V14.9798Z'
                    fill='white'
                />
            </svg>
        )
    },
    {
        name: i18n.t('social:channels.twitter'),
        desc: i18n.t('social:channels.twitterDesc'),
        id: 85,
        disabled: false,
        code: 'TWITTER',
        logo: 'https://cdn1.ourmailserv.com/siteContent/appLogos/85/Twitter-X-Circle-500x500-1.png',
        icon: 'xColor',
        width: 480,
        limit: 280,
        formats: ['JPEG', 'JPG', 'PNG', 'GIF'],
        dimensions: [1024, 512],
        colour: '#37393C',
        hasStats: true,
        fileLimit: 1048576 * 5,
        maxImages: 4,
        click: (post) => {
            window.open(
                'https://twitter.com/' + post.SocialAccount.options.username + '/status/' + post.PostId,
                '_blank'
            )
        },
        chipIcon: (
            <svg
                width='18'
                height='18'
                style={iconChipStyle}
                viewBox='0 0 18 18'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <rect width='18' height='18' fill='#171819' />
                <g clipPath='url(#clip0_462_15973)'>
                    <path
                        d='M9.95136 8.23432L13.6741 4H12.7919L9.55948 7.6766L6.97773 4H4L7.9041 9.55967L4 14H4.88222L8.29576 10.1174L11.0223 14H14L9.95114 8.23432H9.95136ZM8.74304 9.60865L8.34748 9.05503L5.20009 4.64984H6.55512L9.0951 8.20497L9.49067 8.75859L12.7923 13.3797H11.4373L8.74304 9.60886V9.60865Z'
                        fill='white'
                    />
                </g>
                <defs>
                    <clipPath id='clip0_462_15973'>
                        <rect width='10' height='10' fill='white' transform='translate(4 4)' />
                    </clipPath>
                </defs>
            </svg>
        )
    }
]

export function getMeta(url) {
    return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve(img)
        img.onerror = (err) => reject(err)
        img.src = url
    })
}

export function humanizeBytes(bytes) {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
    if (bytes === 0) return '0 Byte'
    const i = Math.floor(Math.log(bytes) / Math.log(1024))
    return parseFloat((bytes / Math.pow(1024, i)).toFixed(2)) + ' ' + sizes[i]
}

export function humanizeDuration(seconds) {
    seconds = Math.round(seconds)
    const days = Math.floor(seconds / (24 * 3600))
    seconds %= 24 * 3600
    const hours = Math.floor(seconds / 3600)
    seconds %= 3600
    const minutes = Math.floor(seconds / 60)
    seconds %= 60

    const daysStr = days > 0 ? `${days}d ` : ''
    const hoursStr = hours > 0 ? `${hours}h ` : ''
    const minutesStr = minutes > 0 ? `${minutes}m ` : ''
    const secondsStr = seconds > 0 ? `${seconds}s` : ''

    return `${daysStr}${hoursStr}${minutesStr}${secondsStr}`.trim()
}

export function validateVideo(video) {
    let err = []
    if (!video) return
    if (!video.meta) return
    if (video.meta.video?.width > 1920 || video.meta.video?.height > 1080) {
        // it might be vertical so check the other way first
        if (video.meta.video?.width < video.meta.video?.height) {
            if (video.meta.video?.width > 1080 || video.meta.video?.height > 1920) {
                err.push('The video dimensions exceed 1080x1920. Please select a video with smaller dimensions.')
            }
        } else {
            err.push('The video dimensions exceed 1920x1080. Please select a video with smaller dimensions.')
        }
    }
    if (video.meta.video?.duration > 90) err.push('The video is longer than 90 seconds. Please upload a shorter video.')
    if (!err.length) return
    return err.map((e) => {
        return (
            <div className='quickFlex' style={{ marginTop: 5 }}>
                <Icons
                    icon='warning'
                    color='var(--red-800)'
                    style={{ width: 20, height: 20 }}
                    className='mar-r10'
                />
                <div style={{ flexGrow: 1, color: 'var(--red-800)' }}>{e}</div>
            </div>
        )
    })
}
